
import React from 'react';
import { polarToCartesian } from '../utils/cycleUtils';
import { sections } from '../config/cycleConfig';
import { getDayAngle } from '../utils/cycleUtils';
import { getDayColor } from '../utils/cycleCalculations';

interface DayNumberProps {
  day: number;
  center: { x: number; y: number };
  currentPhase: {
    phase: string;
    color: string;
    description: string;
    active: boolean;
  } | null;
  isCurrentDay: boolean;
}

export const DayNumber: React.FC<DayNumberProps> = ({ 
  day, 
  center, 
  currentPhase,
  isCurrentDay
}) => {
  const angle = getDayAngle(day);
  const point = polarToCartesian(
    center.x,
    center.y,
    sections.radii.numbers,
    angle
  );

  const rotationAngle = angle + (angle > 90 && angle < 270 ? 180 : 0);
  const dayColor = getDayColor(day, currentPhase);

  return (
    <g>
      {isCurrentDay && (
        <circle
          cx={point.x}
          cy={point.y}
          r="12"
          fill={dayColor}
          stroke="white"
          strokeWidth="2"
        />
      )}
      <text
        x={point.x}
        y={point.y}
        textAnchor="middle"
        dominantBaseline="middle"
        transform={`rotate(${rotationAngle}, ${point.x}, ${point.y})`}
        className={`text-[12px] font-bold ${isCurrentDay ? 'fill-white' : 'fill-gray-800'}`}
      >
        {day}
      </text>
    </g>
  );
};
